import { gql } from '@apollo/client';

/**
 * ТЗ 0114 (#158) — реквизиты преподавателя для фактур (контрагенты) и
 * финансовые условия заявок группы. Имена операций ≠ полям бэкенда. Без
 * `${…}`-вставок: такой шаблон codegen пропускает молча.
 */

export const TeacherBillingEntitiesListQuery = gql`
  query TeacherBillingEntitiesList($teacherId: ID!, $includeInactive: Boolean) {
    teacherBillingEntities(
      teacherId: $teacherId
      includeInactive: $includeInactive
    ) {
      id
      teacherId
      kind
      legalName
      nip
      vatMode
      vatRate
      isDefault
      isActive
      createdAt
      updatedAt
    }
  }
`;

/** Заявки преподавателей группы с условиями («Преподаватели и условия»). */
export const GroupTeacherTermsQuery = gql`
  query GroupTeacherTerms($groupId: ID!) {
    groupTeacherApplications(groupId: $groupId) {
      id
      title
      date
      lessonsCount
      servicePrice
      currency
      isTerminated
      rateUnit
      rateIsGross
      termsMissing
      teacher {
        id
        fullName
      }
      billingEntity {
        id
        teacherId
        kind
        legalName
        nip
        vatMode
        vatRate
        isDefault
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;
